import React from 'react';
import SEOHead from '../components/SEOHead';
import HeroSection from '../components/home/HeroSection';
import CategoriesSection from '../components/home/CategoriesSection';
import BestSellersSection from '../components/home/BestSellersSection';
import LatestUpdateSection from '../components/home/LatestUpdateSection';

import NewArrivalsSection from '../components/home/NewArrivalsSection';
import BlogSection from '../components/home/BlogSection';

const HomePage = () => {
  return (
    <div>
      <SEOHead
        title="Home"
        canonical={window.location.origin}
      />

      {/* Hero */}
      <HeroSection />

      {/* Categories */}
      <CategoriesSection />

      {/* Best Sellers */}
      <BestSellersSection />

      {/* Latest Update */}
      <LatestUpdateSection />
      {/* New Arrivals */}
      <NewArrivalsSection />

      {/* Blog */}
      <BlogSection />
    </div>
  );
};

export default HomePage;

